<section>
  <div id="slider">
    <div id="headerSlider" class="carousel slide" data-ride="carousel">
      <!-- <ol class="carousel-indicators">
        <li data-target="#headerSlider" data-slide-to="0" class="active"></li>

      </ol> -->
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img src="../assets/images/banner1.jpg" class="d-block w-100" />
          <div class="carousel-caption">
            <div class="banner-text">
              <!-- <h4 class="">Our Three Pillars</h4> -->
              <!-- <h5>STRIDE &middot; STRIVE &middot; SOAR</h5> -->
              <h2>Our Team</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



<section id="team">
  <div class="container">
    <h1 class="heading text-center">Our Team</h1>
    <div class="row">
      <ng-container *ngFor="let userDetail of userDetails">
        <div class="col-md-6 col-lg-4" *ngIf="userDetail.email !== 'kchenche@gmail.com'">
          <app-user-item [userDetail]="userDetail"></app-user-item>
        </div>
      </ng-container>
    </div>
  </div>
</section>